<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="3">
          <v-text-field v-model="search_query" label="اسم اثر، اسم فرستنده، شماره فرستنده و..">
          </v-text-field>
          <v-text-field v-model="search_id" label="آیدی اثر">
          </v-text-field>
          <v-select label="تایید پروفایل" :items="items" clearable v-model="profile_valid" item-value="value"
                    item-text="label"/>
          <v-select label="تایید اثر" :items="items" clearable v-model="submission_valid" item-value="value"
                    item-text="label"/>
          <v-select label="دسته‌بندی" :items="submission_categories" clearable v-model="category" item-value="value"
                    item-text="name"></v-select>
        </v-col>
        <v-col cols="12" md="9">
          <v-row>
            <v-col cols="12" lg="4" sm="6" v-for="(field,index) in filterable_selects" :key="index">
              <Field @field_change="change" clearable v-model="filterable_selects[index]"/>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="$store.dispatch('filter_submission')">فیلتر</v-btn>
      <v-btn color="primary" @click="$store.dispatch('copy_filters_to_clipboard')">کپی کردن فیلتر</v-btn>
    </v-card-actions>
  </v-card>

</template>

<script>
import {mapState} from "vuex";
import Field from "@/components/admin/SettingComponents/Field";
import Statics from "@/components/common/Statics";

export default {
  name: "SubmissionListFilterCard",
  components: {Field},
  data: () => {
    return {
      items: [
        {label: "تایید شده", value: true},
        {label: "تایید نشده", value: false},
      ],
      submission_categories: Statics.submission_categories,
      user_types: Statics.user_types
    }
  },
  methods: {
    change(emit_value) {
      let new_object = emit_value.old_object
      new_object.selected = emit_value.new_value
      this.$store.commit('change_select_filter_field_value', {
        field_id: emit_value.old_object.id,
        new_object: new_object
      })
    }
  },
  computed: {
    ...mapState({
      filterable_selects: state => state.Admin.admin.submission_list.filter.filterable_selects,
      categories: state => Statics.submission_categories,
      types: state => Statics.submission_types,
      user_types: state => Statics.user_types
    }),
    search_query: {
      get() {
        return this.$store.state.Admin.admin.search_query
      },
      set(value) {
        this.$store.commit('set_admin_search_query', value)
      }
    },
    profile_valid: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.profile_valid
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_profile_valid', value)
      }
    },
    submission_valid: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.submission_valid
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_submission_valid', value)
      }
    },
    category: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.category
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_category', value)
      }
    },
    type: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.type
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_type', value)
      }
    },
    search_id: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.search_id
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_search_id', value)
      }
    },
    user_type: {
      get() {
        return this.$store.state.Admin.admin.submission_list.filter.user_type
      },
      set(value) {
        this.$store.commit('set_admin_submission_list_filter_user_type', value)
      }
    },
  },
}
</script>

<style scoped>

</style>